var _rect, _rect2, _g, _path, _rect3, _g2, _path2, _path3, _rect4, _g3, _path4, _rect5, _tspan, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTube4Wet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 18,
    viewBox: "0 0 63 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Variant4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 616"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1074",
    x: 10,
    y: 18,
    width: 18,
    height: 43,
    rx: 9,
    transform: "rotate(-90 10 18)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 617"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_428_129553",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 2,
    width: 38,
    height: 14
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1075",
    x: 12,
    y: 16,
    width: 13.7692,
    height: 38,
    rx: 6.88458,
    transform: "rotate(-90 12 16)",
    fill: "#99DFF9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_428_129553)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1076",
    x: 12,
    y: 16,
    width: 13.7692,
    height: 38.9744,
    rx: 6.88458,
    transform: "rotate(-90 12 16)",
    fill: "#004660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1077",
    d: "M18.8846 14.2788C15.0823 14.2788 12 11.1965 12 7.39423C12 3.59198 15.0823 0.509645 18.8846 0.509645L50.9744 0.509644L50.9744 10.2788C50.9744 12.4879 49.1835 14.2788 46.9744 14.2788L18.8846 14.2788Z",
    fill: "#00688F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1078",
    d: "M9.99997 4L9.99997 1L51 1L51 4L9.99997 4Z",
    fill: "#F2F7FC"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 615"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1079",
    d: "M4.10711 13.0282C3.44991 13.5369 2.49506 13.0685 2.49506 12.2374L2.49506 6.20826C2.49506 5.4106 3.38316 4.934 4.04786 5.37495L8.10892 8.06898L8.10892 9.93105L4.10711 13.0282Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 619"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_428_129553",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 6,
    width: 3,
    height: 6
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1078_2",
    x: 10.604,
    y: 6.82764,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(90 10.604 6.82764)",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_428_129553)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1084",
    x: 10.604,
    y: 6.82764,
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "rotate(90 10.604 6.82764)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1082",
    d: "M8.80985 6.20691C9.13117 6.20691 9.40986 6.42552 9.46601 6.7419C9.55587 7.24828 9.66833 8.06819 9.66833 9.00001C9.66833 9.93184 9.55587 10.7517 9.46601 11.2581C9.40986 11.5745 9.13117 11.7931 8.80985 11.7931C8.42274 11.7931 8.10893 11.4793 8.10893 11.0922L8.10893 6.90783C8.10893 6.52072 8.42274 6.20691 8.80985 6.20691Z",
    fill: "#EEEEEE"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1081",
    d: "M1.35744 12.515C0.702677 12.7656 1.23021e-07 12.2822 2.37653e-07 11.5811L9.96796e-07 6.93827C1.10671e-06 6.26604 0.64999 5.78528 1.29276 5.98208L8.10891 8.06903L8.10891 9.9311L1.35744 12.515Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 618"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1079_2",
    d: "M58.8929 13.0282C59.5501 13.5369 60.505 13.0685 60.505 12.2374L60.505 6.20826C60.505 5.4106 59.6169 4.934 58.9522 5.37495L54.8911 8.06898L54.8911 9.93105L58.8929 13.0282Z",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 619_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_428_129553",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 6,
    width: 3,
    height: 6
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1078_3",
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(4.54618e-08 1 1 -4.19222e-08 52.3961 6.82764)",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_428_129553)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1084_2",
    width: 4.34483,
    height: 2.49503,
    rx: 1.24752,
    transform: "matrix(4.54618e-08 1 1 -4.19222e-08 52.3961 6.82764)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1082_2",
    d: "M54.1902 6.20691C53.8689 6.20691 53.5902 6.42552 53.534 6.7419C53.4442 7.24828 53.3317 8.06819 53.3317 9.00001C53.3317 9.93184 53.4442 10.7517 53.534 11.2581C53.5902 11.5745 53.8689 11.7931 54.1902 11.7931C54.5773 11.7931 54.8911 11.4793 54.8911 11.0922L54.8911 6.90783C54.8911 6.52072 54.5773 6.20691 54.1902 6.20691Z",
    fill: "#EEEEEE"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1081_2",
    d: "M61.6426 12.515C62.2974 12.7656 63 12.2822 63 11.5811L63 6.93827C63 6.26604 62.35 5.78528 61.7073 5.98208L54.8911 8.06903L54.8911 9.9311L61.6426 12.515Z",
    fill: "white"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1197",
    x: 38,
    width: 18,
    height: 12,
    transform: "rotate(90 38 0)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("text", {
    id: 1,
    transform: "translate(24.5 3.5)",
    fill: "#333333",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Bio Sans",
    fontSize: 12,
    letterSpacing: "0px"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 4.39062,
    y: 9.7
  }, "4"))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 780",
    d: "M46.7632 10.6842C46.0219 10.6842 45.4211 10.0833 45.4211 9.3421C45.4211 8.60088 46.0219 8 46.7632 8C47.5044 8 49 9.3421 49 9.3421C49 9.3421 47.5044 10.6842 46.7632 10.6842Z",
    fill: "#00AEEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 781",
    d: "M22.7632 5.68421C22.0219 5.68421 21.4211 5.08333 21.4211 4.3421C21.4211 3.60088 22.0219 3 22.7632 3C23.5044 3 25 4.3421 25 4.3421C25 4.3421 23.5044 5.68421 22.7632 5.68421Z",
    fill: "#00AEEF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 782",
    d: "M41.7632 14.6842C41.0219 14.6842 40.4211 14.0833 40.4211 13.3421C40.4211 12.6009 41.0219 12 41.7632 12C42.5044 12 44 13.3421 44 13.3421C44 13.3421 42.5044 14.6842 41.7632 14.6842Z",
    fill: "#00AEEF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 783",
    d: "M14.7632 10.6842C14.0219 10.6842 13.4211 10.0833 13.4211 9.3421C13.4211 8.60088 14.0219 8 14.7632 8C15.5044 8 17 9.3421 17 9.3421C17 9.3421 15.5044 10.6842 14.7632 10.6842Z",
    fill: "#00AEEF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 784",
    d: "M28.0773 17.5658C27.4751 17.5658 26.9869 17.0651 26.9869 16.4474C26.9869 15.8297 27.4751 15.329 28.0773 15.329C28.6796 15.329 29.8948 16.4474 29.8948 16.4474C29.8948 16.4474 28.6796 17.5658 28.0773 17.5658Z",
    fill: "#00AEEF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 785",
    d: "M33.7632 3.68421C33.0219 3.68421 32.4211 3.08333 32.4211 2.3421C32.4211 1.60088 33.0219 1 33.7632 1C34.5044 1 36 2.3421 36 2.3421C36 2.3421 34.5044 3.68421 33.7632 3.68421Z",
    fill: "#00AEEF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 787",
    d: "M13.602 4.78947C13.1387 4.78947 12.7632 4.38889 12.7632 3.89474C12.7632 3.40059 13.1387 3 13.602 3C14.0652 3 15 3.89474 15 3.89474C15 3.89474 14.0652 4.78947 13.602 4.78947Z",
    fill: "#00AEEF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 788",
    d: "M24.602 14.7895C24.1387 14.7895 23.7632 14.3889 23.7632 13.8947C23.7632 13.4006 24.1387 13 24.602 13C25.0652 13 26 13.8947 26 13.8947C26 13.8947 25.0652 14.7895 24.602 14.7895Z",
    fill: "#00AEEF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 789",
    d: "M16.602 16.7895C16.1387 16.7895 15.7632 16.3889 15.7632 15.8947C15.7632 15.4006 16.1387 15 16.602 15C17.0652 15 18 15.8947 18 15.8947C18 15.8947 17.0652 16.7895 16.602 16.7895Z",
    fill: "#00AEEF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 786",
    d: "M42.7994 3.72368C42.3361 3.72368 41.9605 3.32309 41.9605 2.82894C41.9605 2.33479 42.3361 1.9342 42.7994 1.9342C43.2626 1.9342 44.1974 2.82894 44.1974 2.82894C44.1974 2.82894 43.2626 3.72368 42.7994 3.72368Z",
    fill: "#00AEEF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTube4Wet);
export default __webpack_public_path__ + "static/media/tube4_wet.5f5d2a30afe57b228c062909e65aed4b.svg";
export { ForwardRef as ReactComponent };